import ActionsConstants from '../constant/action';
import { ModuleConstants } from '../constant/modules';
import { RoleConfigStore } from '../store';
import { HasPermissionHookInterface } from './types';

interface PermissionConfig {
  [key: string]: { isAccessible: boolean };
}

const checkPermission = (
  id: string,
  config: PermissionConfig,
  publicId: string,
): boolean => {
  if (!id) return false;
  if (id === publicId) return true;

  return config[id]?.isAccessible ?? false;
};

const useHasPermission: HasPermissionHookInterface = () => {
  const roleConfig = RoleConfigStore((state) => state.roleConfig);
  const roleConfigActions = RoleConfigStore((state) => state.roleConfigActions);
  const rolesLoading = RoleConfigStore((state) => state.loading);

  const hasActionPermission = ({ actionId }: { actionId: string }) =>
    roleConfigActions
      ? checkPermission(
          actionId,
          roleConfigActions,
          ActionsConstants.PUBLIC_ACTION_ID,
        )
      : false;

  const hasModulePermission = (
    { moduleId }: { moduleId: string | null }, //TODO: moduleId is mandatory
  ) =>
    roleConfig && moduleId
      ? checkPermission(moduleId, roleConfig, ModuleConstants.PUBLIC_MODULE_ID)
      : false;

  return {
    hasActionPermission,
    hasModulePermission,
    rolesLoading,
  };
};

export default useHasPermission;
